import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';

const forumMeetingsState = () => {
    return {
        baseURL: '',
        forumBaseURL: process.env.VUE_APP_FORUM_BASE_URL,
        forumMeetings: [],
    };
};

const forumMeetingsMutations = {
    [storeMutation.setForumMeetings]: (state, data) => {        
        state.forumMeetings = data;
    },
};

const forumMeetingsActions = {
    [storeAction.getForumMeetingsView]: ({ commit }) => {
        return axios({
            url: '/mocks/ForumMeetings.json',
            // url: 'https://ps-forumapi.ypowpo.org/rest/v1/exercises/get-types',
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setForumMeetings, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
};
const forumMeetingsGetters = {
    [storeGetters.forumMeetings]: state => state.forumMeetings,
};

export default {
    namespaced: true,
    state: {
        initialState: forumMeetingsState(),
        ...forumMeetingsState(),
    },
    mutations: { ...forumMeetingsMutations },
    actions: { ...forumMeetingsActions },
    getters: { ...forumMeetingsGetters },
};
